import { render, staticRenderFns } from "./OJsonTextArea.vue?vue&type=template&id=69e9139e&scoped=true&"
import script from "./OJsonTextArea.vue?vue&type=script&lang=js&"
export * from "./OJsonTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e9139e",
  null
  
)

export default component.exports